// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoBackground_wrapper__DwQ0b","videoMobile":"VideoBackground_videoMobile__B6GrD","videoDesktop":"VideoBackground_videoDesktop__xzQtk"};